<template>
  <form @submit.prevent="createUser">
    <div class="input-style has-icon input-style-1 input-required">
        <i class="input-icon fa fa-envelope font-11"></i>
        <span>Epost</span>
        <em>*</em>
        <input type="email" placeholder="E-post" v-model="email"/>
    </div>
    <div class="input-style has-icon input-style-1 input-required">
        <i class="input-icon fa fa-user font-11"></i>
        <span>Navn</span>
        <em>*</em>
        <input type="text" placeholder="Navn" v-model="name"/>
    </div>
    <div class="input-style has-icon input-style-1 input-required">
        <i class="input-icon fa fa-user font-11"></i>
        <span>Etternavn</span>
        <em>*</em>
        <input type="text" placeholder="Etternavn" v-model="surname"/>
    </div>
    <div class="input-style has-icon input-style-1 input-required">
        <i class="input-icon fa fa-user font-11"></i>
        <span>Stilling</span>
        <em>*</em>
        <input type="text" placeholder="Stilling" v-model="role"/>
    </div>

    <div class="input-style  input-style-1 input-required">
        <span>Tilgang</span>
        <em>*</em>
        <select v-model="access">
            <option disabled selected value="">Type tilgang</option>
            <option v-for="(access, index) in accesses" :value="access" :key="index">
                {{access}}
            </option>
            
        </select>
    </div>

    <p class="feedback" v-if="feedback">{{ feedback }}</p>
    <div class="clear"></div>
    <div class="center-allign">
        <ui-button color="primary" :loading="loading" >Legg til</ui-button>
    </div>
  </form>
</template>

<script>
import * as firebase from 'firebase/app'
import 'firebase/functions'
import 'firebase/firestore'
import 'firebase/storage'

export default {
    name: 'CreateUser',
    data(){
        return{
            email: null,
            name: null,
            surname: null,
            password: null,
            role: null,
            feedback: null,
            loading: false,
            access: null,
            seller: false,
            accesses: ['admin', 'seller', 'reports']
        }
    },
    methods :{
        createUser(){
            if(!this.access){
                this.feedback = 'Vennligst velg bruker type'
            } else {
                this.loading = true
                this.password = this.genPassword(8)
                // console.log(this.password, this.email)
                const addUser = firebase.functions().httpsCallable('addUser');
                addUser({ 
                    email: this.email,
                    password: this.password,
                    name: this.name,
                    surname: this.surname,
                    role: this.role,
                    access: this.access
                })
                .then(result => {
                    if(!result.data.message.errorInfo){
                        //let uid = result.data.message.uid
                        // const ref = firebase.storage().ref().child('users/'.concat(uid,'/profile.jpg'))

                        // ref.put(file)
                        
                            this.feedback = `bruker til ${this.name}, passordet er: ${this.password}`
                            this.email = null
                            this.name = null
                            this.surname = null
                            this.role = null
                    } else {
                        this.feedback = result.data.message.errorInfo.message
                    }
                    this.loading = false
                });
            }
        },
        genPassword(length) {
            let result = '';
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            let charactersLength = characters.length;
            for ( let i = 0; i < length; i++ ) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            return result;
        }
    }
}
</script>

<style>
.center-allign .ui-button {
    width: 100%
}
</style>